import { gql } from 'graphql-request'

export const GET_WRITERS_SALES_REPORTS = gql`
  query GetWriterSalesReports($page: Int, $limitPerPage: Int) {
    getWriterSalesReports(page: $page, limitPerPage: $limitPerPage) {
      data {
        writerTaxId
        writerSendAddress
        writerIncomeSummary
        writerIncomeNovelEbook
        writerIncomeNovelChapter
        writerIncomeMangaEbook
        writerIncomeDonation
        writerIncomeMangaChapter
        writerIncomeCumulative
        writerFullName
        withholdingTax
        paymentCycleYear
        status
        paymentCycleMonth
        paidAt
        paidAfterDeductWithholdingTax
        createdAt
        totalIncomeBeforeDeductWithholdingTax
      }
      page
      total
    }
  }
`
